
import { IonContent, IonGrid, IonRow, IonCol, IonPage } from "@ionic/vue";
import { defineComponent } from "vue";
import GbpFooter from "@/components/Footer.vue";
import PermitDashboard from "@/components/admin/PermitDashboard.vue";
import DataTable from "@/components/admin/DataTable.vue";

export default defineComponent({
  name: "SearchPermitsPage",
  components: {
    IonContent,
    IonPage,
    IonGrid,
    IonRow,
    IonCol,
    GbpFooter,
    PermitDashboard,
    DataTable
  },
  methods: {
    handleScroll($event: any) {
      this.$store.dispatch("setScroll", $event.detail.scrollTop )
    }
  }
});
